import commonText from './commonText';

const hfaModes = {
  hfa_tv: {
    displayLabel: 'HFA TV',
    initialSelected: false,
    initialImpactFactor: 1.5,
    initialDiscount: 0.75,
    costText: '(CPP, use in place of TV/Cable)',
    costTooltip: '(CPP, use in place of TV/Cable)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    icon: 'tv',
  },
  hfa_digital: {
    displayLabel: 'HFA DIGITAL',
    initialSelected: false,
    initialImpactFactor: 0.1,
    initialDiscount: 0.75,
    costText: '(overall CPM, use in place of Digital/Mobile)',
    costTooltip: '(overall CPM, use in place of Digital/Mobile)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    icon: 'mobile',
  },
  hfa_mail: {
    displayLabel: 'HFA MAIL',
    initialSelected: false,
    initialImpactFactor: 1.25,
    initialDiscount: 0.5,
    costText: '(Cost Per Piece, use in place of Direct Mail)',
    costTooltip: '(Cost Per Piece, use in place of Direct Mail)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    icon: 'envelope-o',
  },
  hfa_field: {
    displayLabel: 'HFA FIELD',
    initialSelected: false,
    initialImpactFactor: 1,
    initialDiscount: 0.25,
    costText: '(Cost Per Attempt)',
    costTooltip: '(Cost Per Attempt)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    icon: 'user-o',
  },
};

export default hfaModes;
